import Select from "react-select";
import { Button, Card, Col, Label, Row, Input } from "reactstrap";

import "react-datepicker/dist/react-datepicker.css";
import "./../../../../assets/scss/custom/components/_select.scss";
import { useEffect, useState } from "react";
import StatisticService from "services/Statistic";
import { DELAY_FETCH } from "constant";

const Index = ({
  sites = [],
  filter,
  setFilter,
  error,
  onSearch,
  setError,
  isLoading,
  setPaging,
  selectValue,
  setSelectValue,
  ref,
}) => {
  const [data, setData] = useState([]);
  const [dataHang, setDataHang] = useState([]);
  const [dataCommonName, setDataCommonName] = useState([]);
  const [selectMaHang, setSelectMaHang] = useState([]);
  const [selectCommonName, setSelectCommonName] = useState([]);

  useEffect(() => {
    getDataHang();
    getDataCommonName();
  }, []);

  useEffect(() => {
    if (!selectValue || selectValue.length < 0) return;
    setData(selectValue.filter(x => x.value == "all"));
  }, [selectValue || sites]);

  const getDataHang = async () => {
    const res = await StatisticService.GetLsLabelValueMatHangService({
      search: "",
    });
    res.unshift({ value: "all", label: "Chọn tất cả" });
    setDataHang(res);
  };

  const getDataCommonName = async () => {
    const res = await StatisticService.GetLsCommonNameService({
      search: "",
    });
    res.unshift({ value: "all", label: "Chọn tất cả" });
    setDataCommonName(res);
  };

  const HandleSubmitMaHang = val => {
    let filterAll = val.filter(x => x.value == "all");
    if (filterAll.length > 0) {
      let resfilter = dataHang.filter(item => {
        if (item.value != "all") return item.value;
      });
      setSelectMaHang(filterAll);
      setFilter(prev => ({
        ...prev,
        maHang: resfilter.map(x => x.value),
      }));
    } else {
      setSelectMaHang(val);
      setFilter(prev => ({
        ...prev,
        maHang: val.map(item => item.value),
      }));
    }
    setPaging(prev => ({ ...prev, currentPage: 1 }));
  };

  const HandleSubmitCommonName = val => {
    let filterAll = val.filter(x => x.value == "all");
    if (filterAll.length > 0) {
      setSelectCommonName(filterAll);
      setFilter(prev => ({
        ...prev,
        commonName: dataCommonName.map(item => item.value),
      }));
    } else {
      setSelectCommonName(val);
      setFilter(prev => ({
        ...prev,
        commonName: val.map(item => item.value),
      }));
    }
    setPaging(prev => ({ ...prev, currentPage: 1 }));
  };
  return (
    <Card className="p-3 mb-2">
      <Row>
        <Col>
          <div className="d-flex align-items-center">
            <Label className="mb-0 text-truncate">Mã hãng</Label>
            <div style={{ flex: 1, marginLeft: "6px", zIndex: 2 }}>
              <Select
                className="custom-select"
                isMulti
                options={dataHang}
                placeholder="Chọn hãng"
                value={selectMaHang}
                onChange={val => {
                  HandleSubmitMaHang(val);
                }}
                isDisabled={isLoading}
                styles={{
                  control: base => ({
                    ...base,
                    border: `1px solid ${
                      error && error.siteName ? "red" : "rgb(206, 212, 218)"
                    }`,
                  }),
                }}
              />
            </div>
          </div>
        </Col>
        <Col>
          <div className="d-flex align-items-center">
            <Label className="mb-0 text-truncate">CommonName</Label>
            <div style={{ flex: 1, marginLeft: "6px" }}>
              <Select
                className="custom-select"
                isMulti
                options={dataCommonName}
                placeholder="Chọn xét nghiệm"
                value={selectCommonName}
                onChange={val => {
                  HandleSubmitCommonName(val);
                }}
                isDisabled={isLoading}
                styles={{
                  control: base => ({
                    ...base,
                    border: `1px solid ${
                      error && error.siteName ? "red" : "rgb(206, 212, 218)"
                    }`,
                  }),
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default Index;
